<template>
    <div v-if="isLoaded">
        <v-toolbar dense flat color="white" fixed>
            <v-toolbar-title class="title">Settings</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="save()">
                Save
            </v-btn>
        </v-toolbar>
        <v-row justify="center">
            <v-col cols="12" xs="12" sm="10" md="8">
                <v-select v-model="lang" :items="langs" label="Select language" hint="Default is English" persistent-hint item-text="text" item-value="value"></v-select>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { SET_LANG } from '@/store/mutation-types';

export default {
    name: 'Settings',
    data() {
        return {
            isLoaded: true,
            lang: 'en',
            langs: [
                {
                    text: 'English',
                    value: 'en',
                    icon: '',
                },
                {
                    text: 'Greek',
                    value: 'gr',
                    icon: '',
                },
            ],
        };
    },
    async created() {
        this.lang = this.$store.state.lang || 'en';
        this.isLoaded = true;
    },
    methods: {
        setLang() {
            this.$store.commit(SET_LANG, { lang: this.lang });
            this.$i18n.locale = this.$store.state.lang;
        },
        save() {
            this.setLang();
        },
    },
};
</script>
